import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { CallCenterIcon, StorageUtils } from 'utils';
import { useGetUserStatusQuery, useUpdateUserStatusMutation } from '../../../models/graphql';
import { useKeycloak } from '../../../auth/KeycloakProvider';
import './UserStatus.scss';

const UserStatus: React.FC = () => {
  const [online, setOnline] = useState<undefined | boolean>(false);
  const [onlineTrigger, setOnlineTrigger] = useState<boolean>(false);
  const { initialized } = useKeycloak();
  const customerId = StorageUtils.getCustomerId();

  const { data: initialUserStatus, loading: userStatusLoading } = useGetUserStatusQuery({
    skip: !initialized || !customerId,
  });

  const [updateUserStatus] = useUpdateUserStatusMutation();

  useEffect(() => {
    setOnline(initialUserStatus?.userStatus.active!);
  }, [initialUserStatus?.userStatus.active]);

  useEffect(() => {
    if (online !== undefined && onlineTrigger) {
      updateUserStatus({
        variables: {
          input: {
            active: online,
          },
        },
      });
    }
  }, [online, onlineTrigger]);

  const onClickOnlineHandler = () => {
    setOnline(!online);
    setOnlineTrigger(true);
  };

  return (
    <Button
      loading={userStatusLoading}
      onClick={onClickOnlineHandler}
      className={`${online ? 'user-status online-button online-button--active' : 'offline-button'}`}
    >
      <CallCenterIcon />
      {online ? 'Online' : 'Offline'}
    </Button>
  );
};

export default UserStatus;
